exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form fieldset[data-v-13aabf34],.oi-donation-form input[data-v-13aabf34],.oi-donation-form select[data-v-13aabf34],.oi-donation-form textarea[data-v-13aabf34]{margin-bottom:10px}.oi-donation-form .method-description[data-v-13aabf34]{margin-bottom:10px!important}.oi-donation-form .external-footer[data-v-13aabf34],.oi-donation-form .external-footer p[data-v-13aabf34]{font-size:12px;padding-bottom:10px}.oi-donation-form .external-footer[data-v-13aabf34]{padding-bottom:10px}", ""]);

// exports
